<template lang="pug">
modal-window.modal-academy-edit(:title='title', ref='modalWindow')
  .modal-academy-edit__inner(v-if='academyEditData')
    .modal-academy-edit__inner__body(ref='modalBody')
      .modal-academy-edit__inner__body__error
        .modal-academy-edit__inner__body__error__message.text-small(v-for='message in errorMessages') {{ message }}
      .modal-academy-edit__inner__body__item
        .modal-academy-edit__inner__body__item__label.text-small
          slot(name='academyNameLabel')
        textbox-setting.modal-academy-edit__inner__body__item__input(
          v-model='academyEditData.academyName',
          :placeholder='academyNamePlaceholder'
        )
      .modal-academy-edit__inner__body__item
        .modal-academy-edit__inner__body__item__label.text-small(v-if='isUpdate')
          slot(name='academyCodeDisabledLabel')
        .modal-academy-edit__inner__body__item__label.text-small(v-else)
          slot(name='academyCodeLabel')
        textbox-setting.modal-academy-edit__inner__body__item__input(
          v-model='academyEditData.academyCode',
          :placeholder='academyCodePlaceholder',
          :disabled='isUpdate'
        )
    .modal-academy-edit__inner__footer
      button-modal-keep.modal-academy-edit__inner__footer__button(@click='keep')
        slot(name='keepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/manager/ModalWindow.vue'
import TextboxSetting from '@/components/molecules/manager/TextboxSetting.vue'
import ButtonModalKeep from '@/components/molecules/manager/ButtonModalKeep.vue'
import { AcademyEditType } from '@/models/academyListModel'

/**
 * 教室管理編集モーダル
 */
@Component({
  components: {
    ModalWindow,
    TextboxSetting,
    ButtonModalKeep,
  },
})
export default class ModalAcademyEdit extends Vue {
  // モーダルのタイトル
  @Prop()
  title!: string

  // 編集対象の塾情報
  @Prop()
  academyEditData?: AcademyEditType

  // 塾名プレースホルダー
  @Prop()
  academyNamePlaceholder!: string

  // 塾コードプレースホルダー
  @Prop()
  academyCodePlaceholder!: string

  // 保存ボタン押下時イベント
  @Prop()
  keepButtonEvent!: Function

  // エラーメッセージ
  @Prop()
  errorMessages!: string[]

  // モーダルウィンドウのRef
  @Ref()
  modalWindow!: ModalWindow

  // 入力エリア部のHTLMエレメント
  @Ref()
  modalBody!: HTMLElement

  // 保存処理
  private async keep() {
    await this.keepButtonEvent()
    if (this.errorMessages.length > 0) {
      // エラーメッセージがある場合は入力エリア部のトップまでスクロール
      this.modalBody.scrollTo({ top: 0 })
    } else {
      this.modalWindow.hide()
    }
  }

  public show() {
    this.modalWindow.show()
  }

  // 更新処理であるか
  private get isUpdate(): boolean {
    return !!this.academyEditData?.id
  }
}
</script>

<style lang="stylus" scoped>
.modal-academy-edit
  &__inner
    display flex
    height 463px
    flex-direction column
    align-items flex-start
    gap 20px

    &__body
      display flex
      flex-direction column
      gap 12px
      overflow-y auto

      &__error
        &__message
          color var(--color-manager-modal-alert__text)

      &__item
        width 100%
        display flex
        flex-direction column
        gap 12px

        &__select
          width 100%

    &__footer
      margin-top auto
</style>
